import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

/**
 * @version $Id: custom.ngbdateparserformatter.ts 52286 2017-06-23 23:20:45Z sandro.c.simas $
 */
@Injectable()
export class CustomNgbDateParserFormatter extends NgbDateParserFormatter {

  constructor() {
    super();
  };

  format(date: NgbDateStruct): string {
    if (date === null) {
      return '';
    }
    let momentDate = moment({
      year: date.year,
      month: date.month - 1,
      date: date.day
    });
    return momentDate.isValid() ? momentDate.format('DD/MM/YYYY') : '';
  }

  parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }
    let momentDate = moment(value, 'DD/MM/YYYY');
    return momentDate.isValid() ? {year: momentDate.year(), month: momentDate.month() + 1, day: momentDate.date()} : null;
  }
}


// WEBPACK FOOTER //
// ./src/app/utils/custom.ngbdateparserformatter.ts